import { c as _c } from "react/compiler-runtime";
import { Button, type ButtonProps } from '@chakra-ui/react';
import type { ScoProduct } from '@src/graphql-types';
import type { MouseEvent } from 'react';
import { planChoiceHref, shouldHandlePlanChoiceInPlace } from './planChoice';
type PlanChoiceButtonProps = Omit<ButtonProps, 'asChild'> & {
  product?: ScoProduct | null;
  /**
   * Unmodified click. When omitted, that click follows the payment href.
   * Modified clicks always follow the href.
   */
  onChoose?: () => void;
};

/**
 * A plan CTA whose href is `/accelerator/payment`. Copy-link and open-in-new-tab use that page.
 * A normal click prevents the navigation and runs `onChoose` (the checkout dialog).
 */
export function PlanChoiceButton(t0) {
  const $ = _c(28);
  let children;
  let disabled;
  let onChoose;
  let onClick;
  let product;
  let props;
  if ($[0] !== t0) {
    ({
      children,
      disabled,
      onChoose,
      onClick,
      product,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = disabled;
    $[3] = onChoose;
    $[4] = onClick;
    $[5] = product;
    $[6] = props;
  } else {
    children = $[1];
    disabled = $[2];
    onChoose = $[3];
    onClick = $[4];
    product = $[5];
    props = $[6];
  }
  let t1;
  if ($[7] !== disabled || $[8] !== product) {
    t1 = disabled ? null : planChoiceHref(product);
    $[7] = disabled;
    $[8] = product;
    $[9] = t1;
  } else {
    t1 = $[9];
  }
  const href = t1;
  if (!href) {
    let t2;
    if ($[10] !== onChoose || $[11] !== onClick) {
      t2 = event => {
        onClick?.(event);
        if (onChoose && shouldHandlePlanChoiceInPlace(event)) {
          onChoose();
        }
      };
      $[10] = onChoose;
      $[11] = onClick;
      $[12] = t2;
    } else {
      t2 = $[12];
    }
    let t3;
    if ($[13] !== children || $[14] !== disabled || $[15] !== props || $[16] !== t2) {
      t3 = <Button {...props} disabled={disabled} onClick={t2}>{children}</Button>;
      $[13] = children;
      $[14] = disabled;
      $[15] = props;
      $[16] = t2;
      $[17] = t3;
    } else {
      t3 = $[17];
    }
    return t3;
  }
  let t2;
  if ($[18] !== onChoose || $[19] !== onClick) {
    t2 = event_0 => {
      const inPlace = shouldHandlePlanChoiceInPlace(event_0);
      onClick?.(event_0 as unknown as MouseEvent<HTMLButtonElement>);
      if (!inPlace || !onChoose) {
        return;
      }
      event_0.preventDefault();
      onChoose();
    };
    $[18] = onChoose;
    $[19] = onClick;
    $[20] = t2;
  } else {
    t2 = $[20];
  }
  let t3;
  if ($[21] !== children || $[22] !== href || $[23] !== t2) {
    t3 = <a href={href} onClick={t2}>{children}</a>;
    $[21] = children;
    $[22] = href;
    $[23] = t2;
    $[24] = t3;
  } else {
    t3 = $[24];
  }
  let t4;
  if ($[25] !== props || $[26] !== t3) {
    t4 = <Button {...props} asChild={true}>{t3}</Button>;
    $[25] = props;
    $[26] = t3;
    $[27] = t4;
  } else {
    t4 = $[27];
  }
  return t4;
}
export type { PlanChoiceButtonProps };